import React, { useContext, useEffect, useState } from 'react'
import './Calc.sass'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
// import CalcForm from './CalcForm/CalcForm'
import { AuthContext } from '../../App'
import k1 from './assets/k1.svg'
import k2 from './assets/k2.svg'
import k3 from './assets/k3.svg'
import k4 from './assets/k4.svg'
import CalcForm from './CalcForm/CalcForm'

function Calc() {
  const kitchenForms = [
    { id: 1, title: 'Прямая', icon: k1 },
    { id: 2, title: 'Г-Образная', icon: k2 },
    { id: 3, title: 'П-Образная', icon: k3 },
    { id: 4, title: 'Островная', icon: k4 },
  ]
  return (
    <section id="calc" className="Calc">
      <div className="DefaultContainer">
        <SectionTitle title="Онлайн расчет стоимости вашей кухни" />
        <div className="Calc-Container">
          <div className="KitchenForms">
            <div className="Title">Выберите форму кухни</div>
            {kitchenForms.map((k) => (
              <KitchenFormTile {...k} />
            ))}
          </div>
          <CalcForm />
        </div>
      </div>
    </section>
  )
}

function KitchenFormTile({ title = 'Хай тек', icon }) {
  return (
    <div className="KitchenFormTile">
      <img src={icon} alt={title} />
      <p className="Title">{title}</p>
    </div>
  )
}

export default Calc
